import './styles.scoped.css'
import {Typography, Button, Modal} from '@mui/material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {caregiverApi} from '../../../../services'
import {parseError} from '../../../../utils/helpers'

export default ({open, setOpen, data, loadData, branchId}) => {
    const {setLoading, setMessageBox} = useGlobalStates()

    const handleOk = () => {
        setLoading(true)
        caregiverApi
            .updateCaregiver(branchId, data?.id, {status: 'active'})
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: `Reactivated ${data?.first_name}'s Account`,
                    description:
                        'Reactivating will restore access and scheduling for this caregiver. Make sure any compliance requirements are up to date.',
                })
                loadData()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Typography variant="h6" color="text.primary">
                            {`Reactivate "${data?.first_name}"'s Account?`}
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        Are you sure you want to reactivate this caregiver's account? Reactivating will restore access and scheduling capabilities.
                    </Typography>
                    <br />
                    <div className="actions">
                        <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button variant="contained" fullWidth onClick={handleOk}>
                            Reactivate Account
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
